export function readUploadResponse(response) {
  return response.json().then(data => {
    if (!response.ok || (data && data.success === false)) {
      const message = (data && data.error) || ('Upload failed (HTTP ' + response.status + ').');
      const failures = data && Array.isArray(data.results)
        ? data.results.filter(row => row.ok === false || row.skipped)
        : [];
      const details = failures.map(row => (row.sku || row.upc || 'Row') + ': ' + (row.error || row.reason)).join('; ');
      throw new Error(message + (details ? ' ' + details : ''));
    }
    return data;
  });
}
